/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * MessageBubbleIcon
 */
export default class MessageBubbleIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M12 1c6.58 0 12 4.189 12 9.5 0 3.326-2.154 6.39-5.427 8.132-1.665.886-3.522 1.368-5.35 1.368h-4.89c-.03 0-.059-.001-.088-.004l-5.798 2.898a1 1 0 01-1.417-1.137l1.317-5.273A8.843 8.843 0 010 10.5C0 5.189 5.42 1 12 1zm0 2C6.429 3 2 6.422 2 10.5c0 1.654.626 3.304 1.724 4.527l.019.003a1 1 0 01.727 1.213l-.973 3.89 4.056-2.027a.995.995 0 01.613-.092l.05-.007.117-.007h4.89c1.494 0 3.03-.399 4.41-1.134C20.297 15.45 22 13.026 22 10.5 22 6.422 17.571 3 12 3z" fillRule="nonzero"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

